import { Button } from '@material-ui/core'
import Popover, { PopoverProps } from '@material-ui/core/Popover'
import classnames from 'classnames'
import * as React from 'react'
import ReactSVG from 'react-svg'
import MainMenuService from 'services/mainMenu'
import { isEducator } from 'services/user'

import HamburgerIcon from 'assets/img/hamburger.svg'
import './style.scss'

export interface IPopoverButtonOptions {
  key: string
  label: string
  onClick?: (event?: React.MouseEvent<HTMLElement, MouseEvent>) => void
  className?: string
}

interface IProps {
  children?: React.ReactNode
  buttonOptions: IPopoverButtonOptions[]
  options?: Partial<PopoverProps>
  userData?: any
  hideNotifications?: boolean
}

interface IState {
  anchorEl: (EventTarget & HTMLElement) | null
}

export class PopoverButton extends React.Component<IProps, IState> {
  state: IState = {
    anchorEl: null
  }

  btnRef = React.createRef() as any

  componentDidMount() {
    MainMenuService.openMenu = this.triggerOpenMenu
    MainMenuService.closeMenu = this.triggerCloseMenu
  }

  triggerOpenMenu = () => {
    this.btnRef.current.click()
  }

  triggerCloseMenu = () => {
    this.setState({ anchorEl: null })
  }

  id = () => {
    return this.state.anchorEl ? 'more-options-popover' : undefined
  }

  handleOptionsClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleOptionsClose = () => {
    this.setState({ anchorEl: null })
  }

  getUserName = data => {
    if (data?.full_name) {
      return data.full_name // .split(' ')[0]
    }
    // else {
    return data.first_name
    // }
  }

  render() {
    const {
      children,
      buttonOptions,
      options,
      userData,
      hideNotifications
    } = this.props
    const { anchorEl } = this.state
    const open = Boolean(anchorEl)

    return (
      <div className="popover-button-container">
        {/* //haven't used Material UI Button because doesn't work ref for it*/}
        <button
          ref={this.btnRef}
          aria-describedby={this.id()}
          onClick={this.handleOptionsClick}
          className="popover-trigger"
        >
          <>
            {children || <ReactSVG src={HamburgerIcon} className="hamburger" />}
            {!hideNotifications &&
              userData &&
              !isEducator(userData?.role) &&
              !userData.parental_instructions_complete && (
                <span className="popover-info-counter">1</span>
              )}
          </>
        </button>
        <Popover
          className="popover-container"
          id={this.id()}
          classes={{
            paper: 'popover-container-paper'
          }}
          open={open}
          anchorEl={anchorEl}
          onClose={this.handleOptionsClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          {...options}
        >
          <div className="popover design-fixes">
            {userData && (
              <div className="popover-user-info">
                <p className="popover-user-info__name">
                  {this.getUserName(userData)}
                </p>
                <span
                  title={userData.email}
                  className="popover-user-info__email"
                >
                  {userData.email}
                </span>
              </div>
            )}
            {buttonOptions.map((o, i) => (
              <Button
                key={i}
                className={classnames([
                  'popover-item',
                  o.key,
                  o.key === 'instructions' &&
                    userData &&
                    !userData.parental_instructions_complete &&
                    'uncompleted',
                  o.className
                ])}
                onClick={() => {
                  this.handleOptionsClose()
                  o.onClick?.()
                }}
              >
                {o.label}
              </Button>
            ))}
          </div>
        </Popover>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PopoverButton/index.tsx